<template>
  <button
    v-if="editorAvailable"
    type="button"
    class="btn btn-link p-0 align-baseline text-start mandate-link"
    @click="launcher.open(mandateId)"
  >
    <slot />
  </button>
  <span v-else><slot /></span>
</template>

<script setup lang="ts">
import { useMandateEditorAvailable } from "@/forwards2/components/mandateEditorAvailability";
import { useMandateEditorLauncher } from "@/forwards2/mandates/useMandateEditorLauncher";

/**
 * A mandate's name that opens the mandate editor in place, on whichever page it is shown. The page mounts
 * a `MandateEditorModalHost`, which the launcher drives; a page that cannot open the editor says so
 * (`provideMandateEditorAvailable`) and the name is shown alone.
 */
defineProps<{
  mandateId: number;
}>();

const launcher = useMandateEditorLauncher();
const editorAvailable = useMandateEditorAvailable();
</script>

<style scoped lang="scss">
// Reads as the inline link it replaces, not as a button.
.mandate-link {
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  text-decoration: none;
}
</style>
